// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"224":"my-notes","365":"my-account"}[chunkId] + "." + {"224":"0cf0669f","365":"c3410ee6"}[chunkId] + ".css";
};